// Code generated by Slice Machine. DO NOT EDIT.
// @ts-nocheck

import {defineSliceZoneComponents} from '@prismicio/vue';

import Columns from './Columns/index.vue';
import Faq from './Faq/index.vue';
import Features from './Features/index.vue';
import Form from './Form/index.vue';
import Hero from './Hero/index.vue';
import HubspotSlice from './HubspotSlice/index.vue';
import InvitationVerbatim from './InvitationVerbatim/index.vue';
import PersonaContentSlice from './PersonaContentSlice/index.vue';
import PictureGallery from './PictureGallery/index.vue';
import ReinsuranceSlice from './ReinsuranceSlice/index.vue';
import RichText from './RichText/index.vue';
import Versus from './Versus/index.vue';
import VersusComparison from './VersusComparison/index.vue';
import Video from './Video/index.vue';
import VideoSlice from './VideoSlice/index.vue';
import Pricing from './Pricing/index.vue';

export const components = defineSliceZoneComponents({
    columns: Columns,
    faq: Faq,
    features: Features,
    form: Form,
    hero: Hero,
    hubspot_slice: HubspotSlice,
    invitation_verbatim: InvitationVerbatim,
    persona_content_slice: PersonaContentSlice,
    picture_gallery: PictureGallery,
    pricing: Pricing,
    reinsurance_slice: ReinsuranceSlice,
    rich_text: RichText,
    versus: Versus,
    versus_comparison: VersusComparison,
    video: Video,
    video_slice: VideoSlice,
});
